export { default as FeedbackFlag } from '../components/FeedbackFlag';
